import { DialogDescription } from '@headlessui/react'
import React from 'react'

import './Description.scss'

export type ModalDescriptionPosition = 'left' | 'center'

export interface ModalDescriptionProps {
  children: React.ReactNode
  position?: ModalDescriptionPosition
  'data-testid'?: string
}

const ModalDescription = React.memo(
  ({
    children,
    position = 'left',
    'data-testid': dataTestId = 'modal-description',
  }: ModalDescriptionProps) => {
    return (
      <DialogDescription
        className={['ModalDescription', `ModalDescription--${position}`].join(
          ' ',
        )}
        data-testid={dataTestId}
      >
        {children}
      </DialogDescription>
    )
  },
)

ModalDescription.displayName = 'Modal.Description'

export default ModalDescription
